module.exports = __webpack_public_path__ + "static/media/mentor.0f844bf6.jpg";